import React, { FC, ReactNode } from 'react';
import { fade, Grid, makeStyles, Theme, Typography } from '@material-ui/core';

export interface SilverDescriptionProps {
  result: string;
  description: string;
}
const useStyles = makeStyles((theme: Theme) => ({
  result: {
    width: '95%',
    height: 66,
    border: `2px solid ${theme.palette.primary.main}`,
    boxSizing: 'border-box',
    marginRight: 10,
    fontWeight: 'bold',
    fontSize: 32,
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      width: 109,
    },
  },
  description: {
    fontWeight: 500,
    fontSize: 18,
    lineHeight: '22px',
    marginTop: 13,
    padding: 0,
    [theme.breakpoints.up('md')]: {
      marginTop: 0,
    },
  },
}));
const SilverResults: FC<SilverDescriptionProps> = ({ result, description }) => {
  const classes = useStyles();
  return (
    <Grid xs={4} item>
      <Typography variant={'h6'} color={'primary'} className={classes.result}>
        {result}
      </Typography>
      <Typography color={'textPrimary'} className={classes.description}>
        {description}
      </Typography>
    </Grid>
  );
};

export default SilverResults;
